import { useMemo } from 'react';
import { useIsPartner } from '../partners/partnersQueries';
export const isUnrestrictedPlaylistItem = ({
  visibility
}, isPartner) => (isPartner || visibility !== 'PARTNER') && visibility !== 'IN_TRACK_ONLY';

// extracts items from the playlist that cannot be visualised (track only items, partner, ...)
export const useFilteredRestrictedPlaylistItems = playlistItems => {
  const isPartner = useIsPartner();
  return useMemo(() => (playlistItems === null || playlistItems === void 0 ? void 0 : playlistItems.filter(item => isUnrestrictedPlaylistItem(item, isPartner))) || null, [isPartner, playlistItems]);
};